import { render, staticRenderFns } from "./OnlyOffice.vue?vue&type=template&id=63958288&scoped=true"
import script from "./OnlyOffice.vue?vue&type=script&lang=js"
export * from "./OnlyOffice.vue?vue&type=script&lang=js"
import style0 from "./OnlyOffice.vue?vue&type=style&index=0&id=63958288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63958288",
  null
  
)

export default component.exports